<template>
  <div>
    <!-- <div class="other-container global-full-fixed global-blur" style="background-image:url({{bg_url}});"></div> -->
    <div class="other-container global-full-fixed global-blur" :style="{backgroundImage: 'url(' + bg_url + ')'}" style="background-position:center;"></div>
    <div class="contents-containers">
      <div class="backbtn" @click="backgoto">
        <img :src="backicon" />
      </div>

      <!-- 卡片信息容器 -->
      <div class="cart-containers">
        <!-- 头部 -->
        <div class="cartimg-box" :style="{backgroundImage: 'url(' + bg_url + ')'}"></div>
        <!-- 中间 -->
        <div class="form-box">
          <div class="cu-form-group">
            <div class="title">
              头像
              <span class="global-input-must-tip">*</span>
            </div>
            <div class="flex justify-center align-center" data-type="avatar" @click="linktoCutImg">
              <img v-if="avatar" class="icon-avatorupload" :src="avatar" />
              <!--    <img
                v-else-if="formTemp.avatarUrl"
                class="icon-avatorupload"
                :src="formTemp.avatarUrl"
              />-->
              <img v-else class="icon-avatorupload" :src="formTemp.avatar_url?formTemp.avatar_url:guideIconSlider" />
              <!--  <input v-if="formTemp.avatarUrl" type="text" name="avatarUrl"
              v-model="upImgList==''? formTemp.avatarUrl : upImgList" />-->
              <input v-if="avatar" type="text" name="avatarUrl" v-model="avatar" hidden />
              <input hidden v-else type="text" name="avatarUrl" v-model="userInfo.avatar_url" />
              <img class="icon-rigjt-enter" :src="homeIconEnter" />
            </div>
          </div>
          <div class="cu-form-group">
            <div class="title">
              姓名
              <span class="global-input-must-tip">*</span>
            </div>
            <!--   <input type="text" name="name" @input="usernameVerify"
                            v-model="formTemp.name?formTemp.name:userInfo.nickName" placeholder="请输入姓名" maxlength="10"
            placeholder-class="global-input-placeholder" />-->
            <input type="text" name="name" @input="usernameVerify" v-model="formTemp.name" placeholder="请输入姓名" maxlength="10" placeholder-class="global-input-placeholder" />
          </div>
          <div class="cu-form-group">
            <div class="title">职称</div>
            <!-- <input type="text" name="job_title" @input="jobVerify"
                            v-model="formTemp.job_title?formTemp.job_title:''" placeholder="请输入您的职称" maxlength="10"
            placeholder-class="global-input-placeholder" />-->
            <input type="text" name="job_title" @input="jobVerify" v-model="formTemp.job_title" placeholder="请输入您的职称" maxlength="10" placeholder-class="global-input-placeholder" />
          </div>
          <div class="cu-form-group">
            <div class="title">公司名称</div>
            <!-- <input type="span" @input="nameVerify" name="company_name" maxlength="30"
                            v-model="formTemp.company_name?formTemp.company_name:''" placeholder="请输入公司名称"
            placeholder-class="global-input-placeholder" />-->
            <input type="span" @input="nameVerify" name="company_name" maxlength="30" v-model="formTemp.company_name" placeholder="请输入公司名称" placeholder-class="global-input-placeholder" />
          </div>
          <div class="spanarea-box">
            <div class="spanarea-box-title">公司简介</div>
            <!--    <textarea style="height:160rpx;" @input="companyVerify" maxlength="500" name="company_remark"
                            v-model="formTemp.company_remark?formTemp.company_remark:''" :disabled="modalName!=null"
            placeholder="请填写公司简介" placeholder-class="global-input-placeholder"></textarea>-->
            <textarea @input="companyVerify" maxlength="500" name="company_remark" v-model="formTemp.company_remark" placeholder="请填写公司简介" placeholder-class="global-input-placeholder"></textarea>
          </div>
          <div class="cu-form-group">
            <div class="title">
              手机号
              <span class="global-input-must-tip">*</span>
            </div>
            <input type="text" maxlength="11" name="tel" v-model="formTemp.tel" placeholder="请输入手机号" placeholder-class="global-input-placeholder" />
            <div style="position:relative;" class="flex justify-center align-center">
              <span style="margin-right:5px;" class="global-fonts26 text-blue">保密</span>
              <van-checkbox checked v-model="formTemp.is_tel_show" shape="square" checked-color="#ffbd0a">
              </van-checkbox>
              <!--  <div
                v-else-if="qrcode"
                style="width:1.8918918918918919rem;height:1.8918918918918919rem;"
              >
                <img class="icon-qcodeupload" :src="qrcode" />
                <van-icon
                  name="clear"
                  @click.stop="delQrcode"
                  class="qrcode-del"
                  color="rgb(255,0,0)"
                  size
                />
              </div> -->
            </div>
          </div>
          <div class="cu-form-group">
            <div class="title">微信号</div>
            <input type="text" maxlength="20" name="wx_no" v-model="formTemp.wx_no" placeholder="请输入微信号" placeholder-class="global-input-placeholder" />
          </div>
          <div class="cu-form-group qcode-img-line" style="margin-left:0.2702702702702703rem ">
            <div class="title" @click="showModel">
              <span>微信二维码</span>
              <img class="cu-avatar global-back-transform icon-qcodewhat" :src="mineIconHelp" />
            </div>
            <div style="position:relative;" class="flex justify-center align-center" data-type="qrcode" @click="linktoCutImg">
              <span v-if="!qrcode && !formTemp.qr_code" class="global-fonts26 text-blue">点击上传</span>
              <div v-else-if="qrcode" style="width:1.8918918918918919rem;height:1.8918918918918919rem;">
                <img class="icon-qcodeupload" :src="qrcode" />
                <van-icon name="clear" @click.stop="delQrcode" class="qrcode-del" color="rgb(255,0,0)" size />
              </div>
              <div v-else style="width:1.9rem;height:1.9rem;" class="flex justify-center align-center">
                <img class="icon-qcodeupload" :src="formTemp.qr_code" />
                <van-icon name="clear" @click.stop="delQrcode" class="qrcode-del" color="rgb(255,0,0)" />
              </div>
              <!--     <input type="text" hidden name="qr_code"
              v-model="upcodeList==''? formTemp.qr_code : upcodeList" />-->
              <input type="text" hidden name="qr_code" v-model="formTemp.qr_code" />
              <img class="icon-rigjt-enter" :src="homeIconEnter" />
            </div>
          </div>
          <div class="cu-form-group" @click="linktoLocation" style="margin-left:0.2702702702702703rem ">
            <div class="title flex">
              <span>位置</span>
              <div class="choose-box" :hidden="!formTemp.location">{{formTemp.location}}</div>
              <input type="text" :hidden="hiddenInput" name="longitude" v-model="formTemp.longitude" />
              <input type="text" :hidden="hiddenInput" name="latitude" v-model="formTemp.latitude" />
              <input type="text" :hidden="hiddenInput" name="location" v-model="formTemp.location" />
            </div>
            <div class="flex justify-center align-center">
              <span class="global-fonts26 text-blue" v-if="!formTemp.location">请选择定位</span>
              <img class="icon-rigjt-enter" :src="homeIconEnter" />
            </div>
          </div>
          <div class="cu-form-group">
            <div class="title">详细地址</div>
            <!-- v-model="formTemp.detail?formTemp.detail:''" -->
            <input type="text" name="detail" maxlength="30" @input="detailVerify" v-model="formTemp.detail" placeholder="例18号楼505室" placeholder-class="global-input-placeholder" />
          </div>
          <div class="spanarea-box">
            <div class="spanarea-box-title">自我介绍</div>
            <textarea name="remark" @input="remarkVerify" maxlength="50" v-model="formTemp.remark" placeholder="请填写自我介绍" placeholder-class="global-input-placeholder"></textarea>
          </div>
          <!--           <div class="cu-form-group">
            <div class="form-voice-box">
              <div class="flex" style="width: 100%;margin-top: 12px;align-items: flex-start">
                <audio
                  ref="audiobox"
                  style="display:none;"
                  @ended="handlePause"
                  controls
                  :src="formTemp.voice_remark"
                ></audio>
                <div class="title" style="margin-right: 5px;margin-top:-3px;">录制语音</div>
                <div v-if="formTemp.voice_remark" class="flex">
                  <div
                    class="form-voice-show form-voice-show-active flex align-center"
                    :data-filePath="formTemp.voice_remark"
                    @click="handlePlay"
                  >
                    <span>播放语音{{formTemp.voice_len}}s"</span>
                    <img
                      v-if="isPlay"
                      class="cu-avatar global-back-transform icon-voices"
                      :src="boFang"
                    />
                    <img
                      v-else
                      class="cu-avatar global-back-transform icon-voices"
                      :src="homeIconVoice"
                      alt
                    />
                  </div>
                  <div class="delete-box" @click="handledeleteVoice">
                    <img
                      class="cu-avatar global-back-transform icon-delete"
                      :src="mineIconDelete"
                      alt
                    />
                  </div>
                </div>
                <div v-else class="form-voice-show form-voice-show-no flex align-center">
                  <span>语音未录制</span>
                  <img
                    class="cu-avatar global-back-transform icon-voices"
                    :src="mineIconVoiceDisabled"
                    alt
                  />
                </div>
              </div>
              <button
                class="cu-btn form-voice-say"
                :class="(isSpeaking?'voice-say-active':'voice-say-no')"
                @touchstart="gotouchstart"
                @touchmove="gotouchmove"
                @touchend="gotouchend"
                :hidden="isSpeaking"
              >按住说话</button>
              <button
                class="cu-btn form-voice-say"
                :class="(isSpeaking?'voice-say-active':'voice-say-no')"
                @touchstart="gotouchstart"
                @touchmove="gotouchmove"
                @touchend="gotouchend"
                :hidden="!isSpeaking"
              >松开结束</button>
            </div>
          </div> -->
        </div>
      </div>
      <div class="btns-box flex justify-center align-center">
        <button form-type="submit" class="cu-btn form-btn-submits" @click="formSubmit">提交</button>
      </div>
      <div class="cu-modal" :class="modelName=='swipers'?'show':''">
        <div class="cu-dialog compons-modals">
          <img :src="homeIconClose" class="cu-avatar componts-close-btn" @click="hideModel" />
          <div class="inner-compons-modals">
            <div class="compons-modals-title flex align-center">
              <div class="before-icons"></div>
              <div>获取二维码步骤</div>
            </div>
            <div class="compons-modals-content">
              <img :src="baseimgurl+bannerData[current]" class="slide-image" @click="onClickImgTap" />
            </div>
            <div class="slide-icon">
              <div v-for="(item,index) in bannerData" :key="index" :style="{'background-color': (current==index?'#6599ff':'#d8d8d8')}" class="icon"></div>
            </div>
          </div>
          <img :src="backicon" class="cu-avatar global-back-transform icon-changeIndex icon-clileft" :data-currentpage="current" @click="handlePrev" />
          <img :src="mineIconRight" class="cu-avatar global-back-transform icon-changeIndex icon-cliright" :data-currentpage="current" @click="handleLast" />
        </div>
      </div>
      <!-- 语音图标 -->
      <div :hidden="!tipshow" class="voice-opacity-fixed">
        <div class="voice-icon-inner">
          <div class="icons-inners"></div>
          <div class="icons-content">
            <div class="gif-box">
              <img class="tip-send" :src="yuYin" />
            </div>
            <div class="gif-text">手指上滑，取消发送</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { getcartmsgById, updateCart, createCart } from "../../api/api";
import global from "../../global/global.vue";
import Vue from "vue";
import { Toast, Dialog, CouponList } from "vant";
Vue.use(Toast);
import { HZRecorder } from "../../assets/js/HZRecorder.js";
import { mapState } from "vuex";
var recorder;
let audionum = 0;

export default {
  name: "cartform",
  data () {
    return {
      backicon: require("../../assets/images/mine_icon_left.png"),
      isPlay: false,
      isSpeaking: false,
      bg: "https://api.xianpipa.com/images/template/head/tou1.jpg",
      bg_url: window.localStorage.getItem("bgurl") || global.bgurl,
      styleObj: {
        background:
          'url("https://api.xianpipa.com/images/template/head/tou1.jpg")',
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover"
      },
      baseimgurl: global.baseImgUrl,
      modelName: "",
      current: 0,
      bannerData: [
        "/xianpipa/images/ts_1.png",
        "/xianpipa/images/ts_2.png",
        "/xianpipa/images/ts_3.png",
        "/xianpipa/images/ts_4.png",
        "/xianpipa/images/ts_5.png"
      ],
      qrcodeimgsrc: "",
      upImgList: "",
      upcodeList: "",
      hiddenInput: true,
      formTemp: {
        name: "",
        avatarUrl: "",
        gender: "2",
        city: "xiamen",
        province: "fujian",
        country: "china",
        job_title: "",
        wx_no: "",
        tel: "",
        remark: "",
        company_remark: "",
        company_name: "",
        longitude: "",
        latitude: "",
        location: "",
        detail: "",
        voice_remark: "",
        qr_code: "",
        wx_nickname: "",
        wx_avatar: "",
        voice_len: "",
        upImgList: "",//上传图片
        is_tel_show: ''
      },
      userInfo: {
        avatarUrl:
          "https://api.xianpipa.com/uploads/qrcodes/20190808/qrcode_156525448957505097.png",
        city: "泉州",
        country: "中国",
        gender: 1,
        language: "zh_CN",
        nickName: "Small呆又呆ヽ(`Д´)ﾉ",
        province: "福建"
      },
      startTime: 0,
      tipshow: false,
      avatar: "", //头像或圈子头像
      qrcode: "", //二维码
      userId: null,
      homeIconEnter: require("../../assets/images/home_icon_enter.png"),
      mineIconHelp: require("../../assets/images/mine_icon_help.png"),
      boFang: require("../../assets/images/bofang.gif"),
      homeIconVoice: require("../../assets/images/home_icon_voice.png"),
      mineIconDelete: require("../../assets/images/mine_icon_delete.png"),
      mineIconVoiceDisabled: require("../../assets/images/mine_icon_voice_disabled.png"),
      homeIconClose: require("../../assets/images/home_icon_close.png"),
      mineIconRight: require("../../assets/images/mine_icon_right.png"),
      yuYin: require("../../assets/images/yuyin.gif"),
      guideIconSlider: require("../../assets/images/guide_icon_slider.png")
    };
  },
  created: function () {
    document.title = "编辑名片";
    this.userId = this.$route.query.userid;
    this.avatar = this.$store.getters.getAvatar;
    this.qrcode = this.$store.getters.getQrcode;
    this.getformdata();
    this.getLocation();
  },
  computed: {
    ...mapState(["baseAPI"])
  },
  mounted: function () {
    this.bg_url = window.localStorage.getItem("bgurl") || global.bgurl;
  },
  methods: {
    onClickImgTap: function () {
      return false;
    },
    backgoto: function () {
      //返回时清空数据
      let avatar = "";
      let qrcode = "";
      let formdata = {};
      this.$store.dispatch("changeAvatarFun", avatar);
      this.$store.dispatch("changeQrcodeFun", qrcode);
      this.$store.dispatch("changeformFun", formdata);
      this.$router.go(-1);
    },
    goCropper: function () {
      this.$router.push({
        name: "cropper"
      });
    },
    handlePlay: function () {
      var audio = this.$refs.audiobox;

      if (audionum % 2 == 0) {
        this.isPlay = true;
        audio.play();
      } else {
        this.isPlay = false;
        audio.pause();
      }
      audionum++;
    },
    handlePause: function () {
      this.isPlay = false;
      audionum = 0;
    },
    handledeleteVoice: function () {
      this.isPlay = false;
      this.formTemp.voice_remark = "";
      this.formTemp.voice_len = "";
      audionum = 0;
      /*   recorder.stop();
      recorder.clear(); */
    },
    gotouchstart: function (e) {
      let that = this;
      HZRecorder.get(function (rec) {
        recorder = rec;
        that.startTime = e.timeStamp;
        that.isSpeaking = true;
        that.tipshow = true;
        recorder.start();
      });
    },
    gotouchmove: function () { },
    gotouchend: function (e) {
      let voice_len = Math.ceil((e.timeStamp - this.startTime) / 1000);
      this.formTemp.voice_len = voice_len;
      this.isSpeaking = false;
      this.tipshow = false;
      recorder.stop();
      var blob = recorder.getBlob();
      var formData = new FormData();
      formData.append("file", blob, Date.now() + ".mp3");

      let that = this;
      let baseURL = this.baseAPI;

      //上传
      const instance = axios.create({
        withCredentials: false
      });

      axios.defaults.headers.common["PLATFORM"] = "H5";

      instance
        .post(baseURL + "/file-bases/voices", formData)
        .then(res => {
          let url = res.data.data.url;
          this.formTemp.voice_remark = url;
        })
        .catch(function (error) {
        });

      Toast.success({
        message: "录音成功",
        duration: 1500
      });
    },
    //提交录音
    uploadAudio: function () {
      recorder.upload("/upload", function (state, e) {
        switch (state) {
          case "uploading":
            //var percentComplete = Math.round(e.loaded * 100 / e.total) + '%';
            break;
          case "ok":
            //alert(e.target.responseText);
            alert("上传成功");
            break;
          case "error":
            alert("上传失败");
            break;
          case "cancel":
            alert("上传被取消");
            break;
        }
      });
    },
    linktoCutImg: function (e) {
      this.$router.push({
        name: "cropper",
        params: {
          type: e.currentTarget.dataset.type
        }
      });
    },
    usernameVerify: function () { },
    jobVerify: function () {
      var job_title = this.formTemp.job_title;
      if (job_title.length > 9) {
        Toast({
          message: "职称最多10字哦！",
          duration: 2000
        });
      }
    },
    nameVerify: function () {
      var company_name = this.formTemp.company_name;
      if (company_name.length > 29) {
        Toast({
          message: "公司名称最多30字哦！",
          duration: 2000
        });
      }
    },
    modalName: function () { },
    companyVerify: function () {
      var company_remark = this.formTemp.company_remark;
      if (company_remark.length > 499) {
        Toast({
          message: "公司简介最多500字哦！",
          duration: 2000
        });
      }
    },
    showModel: function () {
      this.modelName = "swipers";
    },
    linktoLocation: function () {
      /*       this.$store.dispatch("changeformFun", this.formTemp); */
      this.$router.push({
        name: "map"
      });
    },
    delQrcode: function () {
      let qrcode = "";
      this.formTemp.qr_code = "";
      this.qrcode = qrcode;

      this.$store.dispatch("changeQrcodeFun", qrcode);
    },
    detailVerify: function () {
      var detail = this.formTemp.detail;
      if (detail.length > 29) {
        Toast({
          message: "详细地址最多30字哦！",
          duration: 2000
        });
      }
    },
    remarkVerify: function () {
      var remark = this.formTemp.remark;
      if (remark.length > 49) {
        Toast({
          message: "自我介绍最多50字哦！",
          duration: 2000
        });
      }
    },
    hideModel: function () {
      this.modelName = "";
      this.current = 0;
    },
    handlePrev: function (e) {
      let idx = e.target.dataset.currentpage;
      idx--;
      if (idx < 0) {
        idx = 4;
      }
      this.current = idx;
    },
    handleLast: function (e) {
      let idx = e.target.dataset.currentpage;
      idx++;
      if (idx == 5) {
        idx = 0;
      }
      this.current = idx;
    },
    backGoBtn: function () {
      let avatar = "";
      let qrcode = "";
      let formTemp = {};
      this.$store.dispatch("changeformFun", formTemp);
      this.$store.dispatch("changeAvatarFun", avatar);
      this.$store.dispatch("changeQrcodeFun", qrcode);

      this.$router.go(-1);
    },
    //获取定位
    getLocation () {
      /*判断是第一次加载还是从location页面返回
        如果从location页面返回，会传递用户选择的地点*/
      let locatInfo = this.$store.getters.getLocationinfo;
      if (locatInfo.address != null && locatInfo.address != "") {
        let urlStr = JSON.parse(locatInfo.location);
        //设置变量 address 的值
        this.formTemp.location = locatInfo.address;
        this.formTemp.longitude = urlStr.lng;
        this.formTemp.latitude = urlStr.lat;
        this.formTemp.detail = locatInfo.name;
      }
      /*  else {
        var geolocation = new qq.maps.Geolocation(
          "BOTBZ-KK5WU-L7AVP-2IK2Y-MR3Y3-MDBR4",
          "鲜枇杷名片"
        );
        geolocation.getLocation(
          locatInfo => {
            this.formTemp.location =
              locatInfo.nation + locatInfo.city + locatInfo.addr;
            this.formTemp.longitude = locatInfo.lng;
            this.formTemp.latitude = locatInfo.lat;
            this.formTemp.detail = "";
          },
          { timeout: 0 }
        );
      } */
    },
    //暂存表单数据
    getformdata: function () {
      let that = this;
      let formdata = that.$store.getters.getFormdata;
      if (formdata.name != null && formdata != "") {
        that.formTemp = formdata;
      } else {
        //初始化表单数据
        let userid = that.$route.query.userid;
        if (userid) {
          //修改页面
          getcartmsgById(userid).then(res => {
            if (res.data.code == 200) {
              let companyData = res.data.data.company_info;
              that.formTemp = res.data.data;
              that.formTemp.avatarUrl = res.data.data.avatar_url;

              that.formTemp.company_name = companyData.company_name;
              that.formTemp.company_remark = companyData.company_remark;
              that.formTemp.detail = companyData.detail;
              that.formTemp.latitude = companyData.latitude;
              that.formTemp.location = companyData.location;
              that.formTemp.longitude = companyData.longitude;
              that.formTemp.tel = window.localStorage.getItem("telphone");

              this.$store.dispatch("changeformFun", that.formTemp);
            }
          });
        } else {
          //新增页面，h5无此情况
        }
      }
    },
    //提交表单
    formSubmit: function () {
      /*  this.avatar = this.$store.getters.getAvatar;
    this.qrcode */

      let items = this.formTemp,
        avatarUrl = this.avatar ? this.avatar : items.avatarUrl,
        name = items.name ? items.name.trim() : "",
        job_title = items.job_title ? items.job_title.trim() : "",
        company_name = items.company_name ? items.company_name : "",
        company_remark = items.company_remark ? items.company_remark : "",
        tel = items.tel ? items.tel.trim() : "",
        wx_no = items.wx_no ? items.wx_no.trim() : "",
        qr_code = this.qrcode ? this.qrcode : items.qr_code,
        longitude = items.longitude ? items.longitude : "",
        latitude = items.latitude ? items.latitude : "",
        detail = items.detail ? items.detail.trim() : "",
        location = items.location ? items.location.trim() : "",
        remark = items.remark ? items.remark.trim() : "",
        wx_avatar = this.userInfo.avatarUrl,
        wx_nickname = this.userInfo.nickName,
        gender = this.userInfo.gender,
        city = this.userInfo.city,
        province = this.userInfo.province,
        country = this.userInfo.country,
        voice_remark = items.voice_remark,
        voice_len = items.voice_len,
        is_tel_show = items.is_tel_show?'2':'1';

      if (!avatarUrl) {
        //没有上传头像时，返回微信默认头像
        avatarUrl = wx_avatar;
      }
      if (!name) {
        Dialog({ message: "请输入姓名" });
        return;
      }
      if (!tel) {
        Dialog({ message: "请输入手机号" });
        return;
      }
      let regStr = /^0?(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
      if (!regStr.test(tel)) {
        Dialog({ message: "手机号格式错误，请重新填写" });
        return;
      }
      if (wx_no) {
        let regWx = /^[a-zA-Z0-9]([-_a-zA-Z0-9]{5,19})+$/;
        if (!regWx.test(wx_no)) {
          Dialog({ message: "微信号格式错误，请重新填写" });
          return;
        }
      }
      if (!voice_remark) {
        voice_remark = "";
        voice_len = "";
      }

      let formjson = {
        name: name,
        avatarUrl: avatarUrl,
        gender: gender,
        city: city,
        province: province,
        country: country,
        job_title: job_title,
        wx_no: wx_no,
        tel: tel,
        remark: remark,
        company_name: company_name,
        company_remark: company_remark,
        longitude: longitude,
        latitude: latitude,
        location: location,
        detail: detail,
        voice_remark: voice_remark,
        qr_code: qr_code,
        wx_avatar: wx_avatar,
        wx_nickname: wx_nickname,
        voice_len: voice_len,
        is_tel_show: is_tel_show
      };
      let userid = this.$route.query.userid;

      createCart(formjson).then(res => {
        if (res.code == 200) {
          Dialog.alert({
            title: "提示",
            message: "提交成功"
          }).then(() => {
            //成功时清空数据
            let avatar = "";
            let qrcode = "";
            let detailmsg = {};
            let formdata = {};
            this.$store.dispatch("changeAvatarFun", avatar);
            this.$store.dispatch("changeQrcodeFun", qrcode);
            this.$store.dispatch("changeDetailmsgFun", detailmsg);
            this.$store.dispatch("changeformFun", formdata);
            this.$router.go(-1);
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.backbtn {
  position: fixed;
  z-index: 50;
  top: 1.3513513513513513rem;
  left: 0.6756756756756757rem;
}
.backbtn img {
  width: 1.8rem;
}
.other-container {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  background-position: center;
}
.global-full-fixed {
  z-index: 0;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
/* 毛玻璃效果 */
.global-blur {
  filter: blur(5px);
  -webkit-filter: blur(6px);
  -moz-filter: blur(6px);
  -ms-filter: blur(6px);
  filter: blur(6px);
  filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius=10, MakeShadow=false);
}
.contents-containers {
  width: 100%;
  padding-bottom: 0.7rem;
}
/* 卡信息容器 */
.cart-containers-opacity {
  margin: 3.72972972972973rem 0.8108108108108109rem 0 0.8108108108108109rem;
  min-height: 35.945945945945944rem;
  background: #ffffff;
  opacity: 0.92;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: -1;
  border-radius: 2.1621621621621623rem 0.5945945945945946rem
    2.1621621621621623rem 0.5945945945945946rem;
  overflow: hidden;
}
.cart-containers {
  margin: 3.72972972972973rem 0.8108108108108109rem 0 0.8108108108108109rem;
  min-height: 31.756756756756758rem;
  background: #ffffff;
  opacity: 0.92;
  border-radius: 2.1621621621621623rem 0.5945945945945946rem
    2.1621621621621623rem 0.5945945945945946rem;
  overflow: hidden;
}
/* 头部 */
.cartimg-box {
  width: 100%;
  height: 8.64864864864865rem;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

/* 中间 */
.form-box {
  padding-bottom: 0.7567567567567568rem;
  margin-top: -0.3rem;
}
.cu-form-group {
  min-height: 2.4324324324324325rem;
  padding: 0rem 0.6216216216216216rem 0 0.7297297297297297rem;
}
.textarea-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 0.2702702702702703rem;
}
.cu-form-group textarea {
  width: 100%;
  height: 2.972972972972973rem;
  margin: 0;
  font-size: 0.7567567567567568rem;
  color: #333;
}
.cu-form-group .title {
  font-size: 0.7567567567567568rem;
  color: #333;
  line-height: normal;
  display: flex;
  align-items: center;
}
.cu-form-group input {
  font-size: 0.7567567567567568rem;
  color: #333;
}
.qcode-image-line {
  min-height: 2.972972972972973rem;
  margin-left: 0.13513513513513514rem;
}
.icon-rigjt-enter {
  width: 0.3783783783783784rem;
  height: 0.7027027027027027rem;
  margin-left: 0.5405405405405406rem;
}
.text-blue {
  color: #69f;
}
.global-fonts26 {
  font-size: 0.7027027027027027rem;
}

.choose-box {
  width: 11.432432432432432rem;
  margin-left: 0.8108108108108109rem;
  /* overflow:hidden;
   text-overflow:ellipsis;
   white-space:nowrap; */
  white-space: wrap;
  line-height: 0.9rem;
}
.form-voice-box {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.form-voice-show {
  width: 8.486486486486486rem;
  height: 1.837837837837838rem;
  font-size: 0.7027027027027027rem;
  border-radius: 0.32432432432432434rem;
  position: relative;
  padding: 0 0.6756756756756757rem;
}
.form-voice-show-no {
  color: #999;
  background-color: #e4e4e4;
  border: solid 1px #dedede;
}
.form-voice-show-active {
  color: #88d32d;
  background-color: #e9fbce;
  border: solid 1px #88d32d;
}
.icon-voices {
  width: 0.5945945945945946rem;
  height: 0.7567567567567568rem;
  position: absolute;
  right: 0.6756756756756757rem;
}
.delete-box {
  padding: 0.2702702702702703rem 0.40540540540540543rem 0.2702702702702703rem
    0.5405405405405406rem;
}
.icon-delete {
  width: 0.7027027027027027rem;
  height: 0.7027027027027027rem;
  margin-left: 0.5405405405405406rem;
}
.icon-qcodewhat {
  margin-left: 0.2702702702702703rem;
  width: 0.918918918918919rem;
  height: 0.918918918918919rem;
}
.cu-btn.form-voice-say {
  width: 13.513513513513514rem;
  height: 2.1621621621621623rem;
  text-align: center;
  border-radius: 0.32432432432432434rem;
  margin-top: 0.5405405405405406rem;
  border: solid 1px #d5d5d5;
  font-size: 0.7567567567567568rem;
}
.cu-btn.voice-say-no {
  background-color: #fefefe;
  color: #333;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.cu-btn.voice-say-active {
  background-color: #ddd;
  color: #444;
}
.form-btn-submits {
  width: 16.216216216216218rem;
  height: 2.4324324324324325rem;
  background-image: linear-gradient(90deg, #ffbd0a, #f9da5b);
  border-radius: 1.2162162162162162rem;
  color: #fff;
  font-size: 0.7567567567567568rem;
  border: 0;
}
.btns-box {
  width: 100%;
  margin-top: 0.7027027027027027rem;
  padding-bottom: 1.027027027027027rem;
  position: relative;
  z-index: 1;
}
.icon-qcodeupload {
  width: 2rem;
  height: 2rem;
  border-radius: 0.21621621621621623rem;
}
.icon-avatorupload {
  width: 1.8918918918918919rem;
  height: 1.8918918918918919rem;
  border-radius: 50%;
}
/* tubiao */
.voice-opacity-fixed {
  width: 8.108108108108109rem;
  height: 8.108108108108109rem;
  border-radius: 0.4864864864864865rem;
  position: fixed;
  bottom: 12.162162162162161rem;
  left: 6.135135135135135rem;
  right: 4.054054054054054rem;
  overflow: hidden;
  z-index: 100;
}
.voice-icon-inner {
  width: 100%;
  height: 100%;
  position: relative;
  padding-top: 0.40540540540540543rem;
}
.icons-inners {
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 4;
}
.icons-content {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 5;
}
.cancle-send {
  width: 2.3783783783783785rem;
  height: 2.891891891891892rem;
}
.tip-send {
  width: 2.5405405405405403rem;
  height: 2.918918918918919rem;
}
.gif-text {
  margin-top: 0.918918918918919rem;
  padding: 0.32432432432432434rem 0.2972972972972973rem;
  border-radius: 0.16216216216216217rem;
  color: #fff;
  font-size: 0.7027027027027027rem;
}

.auto-phone {
  background-image: linear-gradient(90deg, #88d32d, #b5f067);
  color: #fff;
  font-size: 0.7027027027027027rem;
}
.qrcode-del {
  position: absolute;
  top: -0.2783783783783784rem;
  right: 0.6405405405405406rem;
  background-color: #fff;
  border-radius: 50%;
  font-size: 16px;
}

.cu-form-group {
  background-color: var(--white);
  padding: 0.02702702702702703rem 0.8108108108108109rem;
  display: flex;
  align-items: center;
  min-height: 2.7027027027027026rem;
  justify-content: space-between;
  border-top: 0.02702702702702703rem solid #eee;
}
.cu-form-group .title {
  text-align: justify;
  padding-right: 0.8108108108108109rem;
  font-size: 0.8108108108108109rem;
  position: relative;
  /*   height: 1.6216216216216217rem;
  line-height: 1.6216216216216217rem; */
}
.flex {
  display: flex;
}
.align-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.global-input-must-tip {
  font-size: 0.7027027027027027rem;
  color: #f5495a;
  margin-left: 0.1891891891891892rem;
}
.cu-form-group input {
  flex: 1;
  font-size: 0.8108108108108109rem;
  color: #555;
  padding-right: 0.5405405405405406rem;
  border: 0;
}
.cu-form-group textarea {
  display: block;
  width: 100%;
  height: 2.972972972972973rem;
  margin: 0;
  font-size: 0.7567567567567568rem;
  color: #333;
  flex: 1;
}
.spanarea-box {
  display: flex;
  flex-direction: column;
  padding: 0.02702702702702703rem 0.8108108108108109rem;
  border-top: 0.02702702702702703rem solid #eee;
}
.spanarea-box-title {
  text-align: justify;
  padding-right: 0.8108108108108109rem;
  font-size: 0.8108108108108109rem;
  height: 1.6216216216216217rem;
  line-height: 1.6216216216216217rem;
  margin-top: 0.5rem;
}
.spanarea-box textarea {
  display: block;
  width: 100%;
  height: 4.702702702702703rem;
  margin: 0;
  font-size: 0.7567567567567568rem;
  color: #333;
  border: 0;
  background-color: #fff;
}
.text-blue {
  color: #69f;
  font-size: 0.7027027027027027rem;
}

/* ================== 模态窗口 ==================== */
.cu-modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1110;
  opacity: 0;
  outline: 0;
  text-align: center;
  -ms-transform: scale(1.185);
  transform: scale(1.185);
  backface-visibility: hidden;
  perspective: 54.054054054054056rem;
  background: rgba(0, 0, 0, 0.6);
  transition: all 0.3s ease-in-out 0s;
  pointer-events: none;
}
.cu-modal::before {
  content: "\200B";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}
.cu-modal.show {
  opacity: 1;
  transition-duration: 0.3s;
  -ms-transform: scale(1);
  transform: scale(1);
  overflow-x: hidden;
  overflow-y: auto;
  pointer-events: auto;
}
.cu-dialog {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin-left: auto;
  margin-right: auto;
  width: 18.37837837837838rem;
  max-width: 100%;
  background-color: #f8f8f8;
  border-radius: 0.2702702702702703rem;
  overflow: hidden;
}
.cu-modal.bottom-modal::before {
  vertical-align: bottom;
}
.cu-modal.bottom-modal .cu-dialog {
  width: 100%;
  border-radius: 0;
}
.cu-modal.bottom-modal {
  margin-bottom: -27.027027027027028rem;
}
.cu-modal.bottom-modal.show {
  margin-bottom: 0;
}
.cu-modal.drawer-modal {
  transform: scale(1);
  display: flex;
}
.cu-modal.drawer-modal .cu-dialog {
  height: 100%;
  min-width: 5.405405405405405rem;
  border-radius: 0;
  margin: initial;
  transition-duration: 0.3s;
}
.cu-modal.drawer-modal.justify-start .cu-dialog {
  transform: translateX(-100%);
}
.cu-modal.drawer-modal.justify-end .cu-dialog {
  transform: translateX(100%);
}
.cu-modal.drawer-modal.show .cu-dialog {
  transform: translateX(0%);
}
.cu-modal .cu-dialog > .cu-bar:first-child .action {
  min-width: 2.7027027027027026rem;
  margin-right: 0;
  min-height: 2.7027027027027026rem;
}

.compons-modals {
  position: relative;
}
.inner-compons-modals {
  width: 100%;
  height: 100%;
}
.componts-close-btn {
  width: 1.3513513513513513rem;
  height: 1.3513513513513513rem;
  position: absolute;
  top: 1.054054054054054rem;
  right: 1.027027027027027rem;
  background-color: transparent;
  z-index: 90;
}
.compons-modals-title {
  font-size: 0.918918918918919rem;
  color: rgb(51, 51, 51);
  font-weight: bold;
  margin: 0.5405405405405406rem 0 0.98rem;
  width: 10.81081081081081rem;
  letter-spacing: 0.05405405405405406rem;
}
.compons-modals-content {
  height: 14.864864864864865rem;
  font-size: 0.7567567567567568rem;
  line-height: 1.3513513513513513rem;
  color: #666666;
  text-align: left;
  overflow: auto;
}
.before-icons {
  display: inline-block;
  width: 0.16216216216216217rem;
  height: 0.8648648648648649rem;
  background-color: #ffbd0a;
  margin-right: 0.4864864864864865rem;
  margin-bottom: -0.13513513513513514rem;
}
/* Image */
.image-top-message {
  text-align: left;
  margin-left: 0.8378378378378378rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.wexin-topname {
  font-size: 0.918918918918919rem;
  color: #333333;
  margin-bottom: 0.2702702702702703rem;
  font-weight: 550;
  font-family: "SimHei";
}
.wexin-toparea {
  font-size: 0.7027027027027027rem;
  color: #666666;
}
.lines-copys {
  font-size: 0.7567567567567568rem;
  padding: 0.6756756756756757rem 0;
}
.weixin-copy {
  display: inline-block;
  color: #6699ff;
  padding-left: 0.5945945945945946rem;
}
.modal-qcode-img {
  width: 14.35135135135135rem;
  height: 14.297297297297296rem;
}
.models-bottom-tips {
  font-size: 0.7027027027027027rem;
  color: #999999;
  margin-top: 0.5405405405405406rem;
}
/* swiper */
swiper {
  height: 14.378378378378379rem;
}
.slide-image {
  width: 100%;
  height: 14.378378378378379rem;
}
.slide-icon {
  display: flex;
  justify-content: center;
}
.slide-icon .icon {
  width: 0.4594594594594595rem;
  height: 0.4594594594594595rem;
  background-color: #6599ff;
  border-radius: 50%;
  margin: 1.0810810810810811rem 0.2702702702702703rem 0;
}
.wx-swiper-dots {
  position: absolute;
}
.wx-swiper-dots.wx-swiper-dots-horizontal {
  bottom: -0.2702702702702703rem;
}
.icon-changeIndex {
  width: 1.4594594594594594rem;
  height: 1.4594594594594594rem;
  border-radius: 50%;
  position: absolute;
  top: 8.162162162162161rem;
  padding: 0.35135135135135137rem;
  z-index: 50;
}
.icon-clileft {
  left: 0;
}
.icon-cliright {
  right: 0;
}
.compons-modals {
  width: 16.15946rem;
  height: 19.848649rem;
  padding: 0.5675675675675675rem 1.1216216216216216rem 0.4864864864864865rem
    1.0945945945945946rem;
  position: fixed;
  top: 7.783784rem;
  left: 0.82432rem;
}

.back-gobtn {
  position: fixed;
  z-index: 50;
  top: 1.3513513513513513rem;
  left: 0.8756756756756757rem;
  width: 1.5675675675675675rem;
  height: 1.5675675675675675rem;

  background: rgba(0, 0, 0, 0.38);
  border-radius: 50%;
}
.back-gobtn img {
  width: 0.5945945945945946rem;
  height: 1rem;
  padding: 0;
  margin: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/cartform.vue